module.exports = __webpack_public_path__ + "3af51938c9e8059b26eda45809c11778.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/projekte/lankenau01.jpg
// module id = 657
// module chunks = 0